import BookIcon from '@material-ui/icons/Book'
import OrderShow from './OrderShow'
import OrderList from './OrderList'

export default {
  list: OrderList,
  show: OrderShow,
  icon: BookIcon,
}
